import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';
import './index.scss';

export default function ErrorMagComponent(props) {
  const {
    msgInfo,
    componentClass = "error-msg-cont"
  } = props;

  return (
    <div className={componentClass}>
      <ErrorIcon className="icon" />
      <p className='msg-text'>{msgInfo}</p>
    </div>
  );
}